import { DATE_FORMAT } from '../../../constants/service/common/utilConstants';
import {
  BALANCE_BRAND_SEARCH_BOX_TYPE,
  BALANCE_SEARCH_DATE_TYPE,
} from '../../../constants/service/app/balanceConstants';
import moment, { setDateFormat } from '../../../lib/moment';

/**
 *  정산 브랜드 리스트 검색 옵션 모델
 */
export const BALANCE_BRAND_LIST_SEARCH_OPTION_MODEL = {
  // 브랜드 검색
  brandSearch: {
    // 브랜드 검색 타입
    type: BALANCE_BRAND_SEARCH_BOX_TYPE.STORE_ID,
    // 검색 데이터
    text: null,
  },
  // 상품 관리 타입
  productManagementType: [],
  // 정산 주기 타입
  balancePeriodType: null,
  // 정산일
  balanceDay: null,
  // 정산 주기
  balancePeriod: null,
};

/**
 *  정산 집계 데이터
 */
export const BALANCE_SUMMARY_BOX_MODEL = {
  /**
   *  총 고객 결제금액
   */
  totalPrice: null,
  /**
   *  총 포인트 사용 금액
   */
  totalUsedPoint: null,
  /**
   *  총 쿠폰 사용 금액
   */
  totalUsedCouponPrice: null,
  /**
   *  PG사 판매수수료
   */
  totalPgFee: null,
  /**
   *  AMONDZ 판매수수료
   */
  totalAmondzFee: null,
  /**
   *  총 정산 금액
   */
  totalFinalBalance: null,
  /**
   *  총 제품 판매 수
   */
  totalItemQuantity: null,
};

/**
 *  정산 리스트 검색 옵션 모델
 */
export const BALANCE_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  날짜 검색
   */
  searchDate: {
    type: BALANCE_SEARCH_DATE_TYPE.DUE_DATE,
    data: {
      period: {
        startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
        endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
      },
    },
  },
  /**
   *  정산 주기 타입
   */
  balancePeriodType: null,
  /**
   *  정산일
   */
  balanceDay: null,
  /**
   *  정산 주기
   */
  balancePeriod: null,
};

/**
 *  정산 리스트 필터 옵션 모델
 */
export const BALANCE_LIST_FILTER_OPTION_MODEL = {
  /**
   *  정산번호
   */
  balanceId: null,
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  예금주
   */
  accountHolder: null,
  /**
   *  계좌번호
   */
  accountNumber: null,
  /**
   *  은행
   */
  accountBank: null,
};

/**
 *  정산 리스트 정렬 옵션 모델
 */
export const BALANCE_LIST_SORT_OPTION_MODEL = [
  /**
   *  정산번호
   */
  {
    id: 'balanceId',
    desc: true,
  },
  /**
   *  정산 예정일
   */
  {
    id: 'dueDate',
    desc: true,
  },
  /**
   *  정산 기준일
   */
  {
    id: 'baseDate',
    desc: true,
  },
];

/**
 *  정산 완료 리스트 정렬 옵션 모델
 */
export const BALANCE_DONE_LIST_SORT_OPTION_MODEL = [
  /**
   *  정산번호
   */
  {
    id: 'balanceId',
    desc: true,
  },
  /**
   *  정산 완료일
   */
  {
    id: 'completeDate',
    desc: true,
  },
];

/**
 *  정산 리스트 검색 박스 모델
 */
export const BALANCE_LIST_SEARCH_DATA_MODEL = {
  /**
   *  날짜 검색
   */
  searchDate: {
    type: BALANCE_SEARCH_DATE_TYPE.DUE_DATE,
    data: {
      /**
       *  빠른 날짜 선택 값
       */
      quickDateIndex: 0,
      period: {
        startDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
        endDate: setDateFormat(moment(), DATE_FORMAT.YMD_DASH_FORMAT),
      },
    },
  },
  /**
   *  정산 주기 타입
   */
  balancePeriodType: null,
  /**
   *  정산일
   */
  balanceDay: null,
  /**
   *  정산 주기
   */
  balancePeriod: null,
};

/**
 *  정산 정보
 */
export const BALANCE_INFO_MODEL = {
  /**
   *  정산번호
   */
  balanceId: null,
  /**
   *  브랜드명
   */
  brandName: null,
  /**
   *  상점번호
   */
  storeId: null,
  /**
   *  정산 기준일
   */
  baseDate: null,
  /**
   *  정산 예정일
   */
  dueDate: null,
  /**
   *  정산 상태
   */
  status: null,
  /**
   *  판매자 전화번호
   */
  sellerPhone: null,
  /**
   *  정산 완료일
   */
  completeDate: null,
  /**
   *  총 제품 판매 수
   */
  totalItemQuantity: null,
  /**
   *  총 결제금액
   */
  totalPrice: null,
  /**
   *  수수료합
   */
  totalSumFee: null,
  /**
   *  쿠폰 사용 금액
   */
  totalUsedCouponPrice: null,
  /**
   *  포인트 사용액
   */
  totalUsedPoint: null,
  /**
   *  PG 수수료
   */
  totalPgFee: null,
  /**
   *  PG 수수료 VAT
   */
  totalPgFeeVat: null,
  /**
   *  마케팅 수수료
   */
  totalMarketingFee: null,
  /**
   *  마케팅 수수료 VAT
   */
  totalMarketingFeeVat: null,
  /**
   *  AMONDZ 수수료
   */
  totalAmondzFee: null,
  /**
   *  AMONDZ 수수료 VAT
   */
  totalAmondzFeeVat: null,
  /**
   *  풀필먼트 수수료
   */
  totalFulfillmentFee: null,
  /**
   *  풀필먼트 수수료 VAT
   */
  totalFulfillmentFeeVat: null,
  /**
   *  은행명
   */
  bankName: null,
  /**
   *  예금주
   */
  accountHolder: null,
  /**
   *  계좌번호
   */
  accountNumber: null,
  /**
   *  정산 예정 금액
   */
  finalBalance: 0,
  /**
   *  정산 집행 금액
   */
  paidBalance: 0,
  /**
   *  정산 보류 금액
   */
  holdBalance: 0,
  /**
   *  정산 추가 금액
   */
  extraBalance: 0,
  /**
   *  메모
   */
  memo: null,
};
